import { useLocation, useNavigate, useParams } from 'react-router-dom';

/**
 * withRouter compatibility shim for React Router v7.
 * Provides location, navigate (as history-like), and params props.
 */
export function withRouter(Component) {
	function ComponentWithRouterProp(props) {
		const location = useLocation();
		const navigate = useNavigate();
		const params = useParams();

		// Create a history-like object for backward compatibility
		const history = {
			push: (pathOrObj) => {
				if (typeof pathOrObj === 'string') {
					navigate(pathOrObj);
				} else {
					navigate(pathOrObj.pathname, { state: pathOrObj.state });
				}
			},
			replace: (pathOrObj) => {
				if (typeof pathOrObj === 'string') {
					navigate(pathOrObj, { replace: true });
				} else {
					navigate(pathOrObj.pathname, { state: pathOrObj.state, replace: true });
				}
			},
			goBack: () => navigate(-1),
			goForward: () => navigate(1),
			go: (n) => navigate(n),
			listen: () => () => {}, // no-op, use useEffect + location instead
			location,
			block: () => () => {}, // no-op placeholder
		};

		return (
			<Component
				{...props}
				location={location}
				navigate={navigate}
				params={params}
				history={history}
				match={{ params }}
			/>
		);
	}

	const displayName = Component.displayName || Component.name || 'Component';
	ComponentWithRouterProp.displayName = `withRouter(${displayName})`;

	return ComponentWithRouterProp;
}

export default withRouter;
